import React,{useEffect, useState} from "react"
import { useParams } from "react-router-dom"

import { Row, Col, Card, CardBody, CardTitle, InputGroup, Label, FormGroup, Button, Modal, Pagination, PaginationItem, PaginationLink } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions";
import moment from "moment"
import { RingLoader } from "react-spinners";
import { BarLoader } from "react-spinners";

const PlanningDetail = (props) => {
  document.title = "Planning | Interface de plannification des agents";
  const { id } = useParams();
  const breadcrumbItems = [
    { title: "ueDigital", link: "/dashboard" },
    { title: "Rapports", link: "#" },
    { title: "Planning des agens", link: "#" },
  ]
  const [loadingPlanning, setLoadingPlanning] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [users, setUsers] = useState([]);
  const [poste, setPoste] = useState('');
  const [selectedUser, setSelectedUser] = useState([]);
  const [details, setdetails] = useState([]);
  const [lockMessage, setLockMessage] = useState(null);
  const [plannings, setPlannings] = useState([]);
  const [totalPlannings, setTotalPlannings] = useState(0);
  const [car, setCar] = useState("");
  const [bordSend, setBordSend] = useState("");
  const [agTransit, setAgTransit] = useState(null);
  const [heure, setHeure] = useState(moment().format("YYYY-MM-DD HH:mm"));
  const [selectedAgTransit, setSelectedAgTransit] = useState(null);
  const handleAgTransit= (event)=>{ setSelectedAgTransit(event); setAgTransit(event.value); }
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const optionGroup = [ { options: users } ]
  const [modal_opera, setmodal_opera] = useState(false)
  const [modal_lock, setmodal_lock] = useState(false)
  const [modal_send, setmodal_send] = useState(false)
  let [loading, setLoading] = useState(false);
  let [lockLoading, setLockLoading] = useState(false);
  const [msgError, setMsgError]= useState("");
  const [msgSuccess, setMsgSuccess]= useState("");
  const handleStartDate= (date)=>{ setStartDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleEndDate= (date)=>{ setEndDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleSendDate= (date)=>{ setHeure(moment(date[0]).format("DD-MM-YYYY HH:mm")); }
  const handleDestination= (event)=>{ setSelectedUser(event); }
  const userJson= JSON.parse(localStorage.getItem("user"));

  const loadUsers= ()=> {
    let userJson= JSON.parse(localStorage.getItem("user"));
    let usersArray= [{label: "Aucun transit", value: null}];
    fetch(`${url.BACKEND_URL}/user?agence=${userJson.usAgence.agId}&size=100`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        usersArray=[
          ...usersArray,
          ...responseJson.data.map(item=>({
          label: item.usNom,
          value: item.usId
        }))];
        setUsers(usersArray);
    } else {  }
    }) .catch((error) => {  });
  };
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  function tog_get_opera() {
    setmodal_opera(!modal_opera)
    removeBodyCss()
  }
  function tog_lock_bord() {
    setmodal_lock(!modal_lock)
    removeBodyCss()
  }
  function tog_send_bord() {
    setmodal_send(!modal_send)
    removeBodyCss()
  }
  const loadDetail=(page)=> {
    setLoadingPlanning(true)
    fetch(`${url.BACKEND_URL}/repartition-poste/${id}`, {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { console.log(responseJson.data);
      if (responseJson.status==200) { 
        setPlannings(responseJson.data)
        setTotalPlannings(responseJson.totalElement)
        setTotalPage(responseJson.totalPage)
        setCurrPage(responseJson.current_page)
        setLoadingPlanning(false)
    } else {  setLoadingPlanning(false) }
    }) .catch((error) => { setLoadingPlanning(false) });
  };
  
  const verifData= ()=>{
    if (poste.trim()==="") { setMsgError("Veuillez entrer le poste svp"); return false;}
    else if (selectedUser.length==0) { setMsgError("Veuillez sélectionner les agents concernés"); return false;}
    else {return true; }
  }

  const saveDetail=()=>{
    if (verifData()) {
      const data=JSON.stringify(
          {
            repartition: {id: id},
            poste: poste,
            users: selectedUser.map(u => ({ usId: u.value }))
          });
          console.log(data);
          
      fetch(`${url.BACKEND_URL}/repartition-poste`, { method: 'POST', headers: {'Content-Type': 'application/json' },
        body: data })
      .then((response) => response.json())
      .then((responseJson) => { console.log(responseJson.data);
        if (responseJson.status==200) { 
          loadDetail();
          setMsgSuccess(responseJson.message)
          tog_get_opera()
          setPoste("")
          setSelectedUser([])
          setTimeout(() => { tog_send_bord(); }, 500); 
      } else {  }
      }) .catch((error) => {  });
    }
    
  }

  useEffect(() => {
    props.setBreadcrumbItems('Bordereaux', breadcrumbItems)
    loadUsers()
    loadDetail(0)
  }, [])

  const getOperation=(item)=> {
    return (
        <Row>
          <Col xl="12">
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0" data-pattern="priority-columns">
              <Table id="tech-companies-1" className="table table-striped table-bordered">
              <Tbody>
                      {details.map((item, key)=>(
                      <Tr>
                        <Th>
                          <strong>{item.poste}</strong>
                        </Th>
                        <Td style={{ fontSize: 9 }}><strong>{item.users?.map(u => u.usNom).join(", ")}</strong></Td>
                      </Tr>
                      ))}
                    </Tbody>
              </Table>
              </div>
            </div>
          </Col>
        </Row>);
      };

  return (
    <React.Fragment>
      
      <Modal
        size="l"
        isOpen={modal_opera}
        toggle={() => { tog_get_opera() }}
        >
        <div className="modal-header bg-primary text-white">
          <h2 className="modal-title mt-0" id="myLargeModalLabel">Ajouter le planning des postes</h2>
          <button
            onClick={() => {
              setmodal_send(false)
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true" style={{ color: "black" }}>x</span>
          </button>
        </div>
        <div className="modal-body">
          <Col xl="12">
            <FormGroup className="mb-4">
              <div className="mb-3">
                <label className="form-label" htmlFor="formrow-firstname-input">Poste</label>
                <input type="text" value={poste} onChange={(event)=>setPoste(event.target.value)} className="form-control" id="exp" placeholder="Libellé du poste"/>
              </div>
            </FormGroup>
          </Col>
          <Col xl="12">
            <FormGroup className="mb-4">
              <Select
                  isMulti
                  value={selectedUser}
                  onChange={handleDestination}
                  options={optionGroup}
                  classNamePrefix="select2-selection"
                />
            </FormGroup>
          </Col>
          <Col xl="12">
            <Button className="btn btn-lg btn-primary" style={{ width: "100%" }} tag="button" onClick={() => {saveDetail()}}>
              ENREGISTRER
            </Button>
          </Col>
          <Col xl="12">
            <strong className="text-danger" style={{ width: "100%" }}>
              {msgError}
            </strong>
          </Col>
        </div>
        
      </Modal>
      <Row className="mb-4">
        <Col xl="4">
          <Button className="btn btn-lg btn-info" tag="button" data-toggle="modal" data-target=".bs-example-modal-lg" onClick={() => {tog_get_opera()}}>
            AJOUTER LES POSTES
          </Button>
        </Col>
      </Row>
      <Row>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              
              <Flatpickr
                className="form-control d-block"
                placeholder="Date début"
                value={startDate}
                onChange={handleStartDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date Fin"
                value={endDate}
                onChange={handleEndDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        
        <Col lg="3">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={()=>{loadDetail(0)}} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Rechargé</Button>
          </div>
        </Col>
      </Row>
     <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{totalPlannings} élément(s) </CardTitle>
              <Card>
                {totalPage ==0 ? ( null): totalPage>=25 ? (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: 25}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadDetail(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadDetail(totalPage-1)}>......{totalPage-1}</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink onClick={()=>loadDetail(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>): (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: totalPage}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadDetail(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadDetail(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>)}
              </Card>

              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <div>
                    {loadingPlanning ? (<BarLoader width={"100%"} height={6}/>): null}
                  </div>
                  <Table
                    id="tech-companies-1"
                    className="table table-striped table-bordered"
                  >
                    <Thead>
                      <Tr>
                        <Th data-priority="1">Poste</Th>
                        <Th data-priority="3">Agents</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {plannings.map((item, key)=>(
                      <Tr>
                        <Td>{item.poste}</Td>
                        <Td>{item.users?.map((u, i) => (<Button key={i} className="btn btn-secondary btn-sm me-1 mb-1">{u.usNom}</Button>))}</Td>
                      </Tr>
                      ))}
                      
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}
export default connect(null, { setBreadcrumbItems })(PlanningDetail);